import { Flex, Spinner } from '@chakra-ui/react'

import theme from 'theme'

import type { FlexProps, SpinnerProps } from '@chakra-ui/react'

type Props = FlexProps & {
  size?: SpinnerProps['size']
}

const Loading = (props: Props) => {
  const { size, ...containerProps } = props
  return (
    <Flex w="100%" justifyContent="center" p={4} {...containerProps}>
      <Spinner size={size} color={props.color ?? theme.baseColors.secondary.main} />
    </Flex>
  )
}

export default Loading
